import {
  getAsync,
  postAsync,
  uploadAsync,
  putAsync,
  deleteAsync
} from "../helpers/apiHelper";

const endpoint = process.env.VUE_APP_BACKEND + "/api/draggables";

// GET all draggables for current user
export async function getAllDraggablesForCurrentUserAsync() {
  return await getAsync(`${endpoint}/GetAllForCurrentUser`);
} 

// GET all discipline draggables for a discipline
export async function getAllDisciplineDraggablesForDisciplineAsync(disciplineId) {
  return await getAsync(`${endpoint}/GetAllDisciplineDraggablesForDiscipline/${disciplineId}`);
}

// GET all draggable categories for a discipline
export async function getAllDraggablesCategoriesAndRelatedDraggablesForDisciplineAsync(disciplineId) {
  return await getAsync(`${endpoint}/GetAllDraggablesCategoriesAndRelatedDraggablesForDiscipline/${disciplineId}`);
}

// GET all draggable categories available for a discipline
export async function getAllDraggablesCategoriesAndRelatedDraggablesAvailableForDisciplineAsync(disciplineId) {
  return await getAsync(`${endpoint}/GetAllDraggablesCategoriesAndRelatedDraggablesAvailableForDiscipline/${disciplineId}`);
}

// GET all draggables for a federation
export async function getAllDraggablesCategoriesAndRelatedDraggablesForFederationAsync(federationId) {
  return await getAsync(`${endpoint}/GetAllDraggablesCategoriesAndRelatedDraggablesForFederation/${federationId}`);
}

// CREATE a draggable for a federation
export async function createDraggableForFederationAsync(federationId, model) {
  return await uploadAsync(`${endpoint}/CreateForFederation/${federationId}`, model);
}

// CREATE a draggable for a discipline
export async function createDraggableForDisciplineAsync(disciplineId, model) {
  return await uploadAsync(`${endpoint}/CreateForDiscipline/${disciplineId}`, model);
}

// UPDATE a draggable for a federation
export async function updateDraggableAsync(draggableId, model) {
  return await putAsync(`${endpoint}/${draggableId}`, model);
}

// DELETE a draggable
export async function deleteDraggableAsync(draggableId) {
  return await deleteAsync(`${endpoint}/${draggableId}`);
}

// AFFECT a draggable to a discipline
export async function affectDraggableToDisciplineAsync(model) {
  return await postAsync(`${endpoint}/AffectDraggableToDiscipline`, model);
}

// UNAFFECT a draggable to a discipline
export async function unaffectDraggableToDisciplineAsync(model) {
  return await postAsync(`${endpoint}/UnaffectDraggableToDiscipline`, model);
}

// GET one draggble string path
export function getDraggableStringUrl(path) {
  return `${endpoint}/get?path=${path}`;
}